import React from 'react'
import { Button } from 'reactstrap'
import { noop } from 'lodash'

interface IbtnProps {
  btnText?: any | string | Element | null
  onClick?: (parmas?: any) => void
  disabled?: boolean
  type?: string
  color?: string
  classes?: string
  styles?: any
  isPill?: boolean
  loading?: boolean
}
const colorClass = (type: string): string => {
  switch (type) {
    case 'primary':
      return 'btn-primary'
    case 'secondary':
      return 'btn-secondary'
    case 'danger':
      return 'btn-danger'
    default:
      return ''
  }
}
const Buttons: React.FC<IbtnProps> = props => {
  const {
    onClick = noop,
    disabled = false,
    classes = '',
    type = 'button',
    color = 'primary',
    isPill = false,
    loading = false
  } = props
  const pillStyles = {
    fontSize: '13px',
    fontWeight: '400',
    paddingLeft: '6px',
    paddingRight: '6px',
    paddingTop: '4px',
    paddingBottom: '4px',
    textTransform: 'uppercase'
  }

  return (
      <Button
        type={type}
        style={isPill ? pillStyles : props.styles}
        color={color}
        className={`btn ${colorClass(color)} text-uppercases ${classes} flex-button`}
        onClick={loading ? noop : onClick}
        disabled={disabled}
      >
        {props.btnText || props.children}
        {loading && <em className="fas fa-circle-notch fa-spin ml-1" />}
      </Button>
    )
  }

export default Buttons
